import * as React from "react";
import NavMenu from "../NavMenu";

const MenuBar: React.StatelessComponent<any> = () => {
  return <NavMenu />;
};
export default MenuBar;
